export default __webpack_public_path__ + "static/media/home3.cb09fb0b.svg";